import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/cambiolada',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteCambioLadaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Cambios de LADA</PageTitle>
      <View />
    </>
  );
};

export { ReporteCambioLadaPage };
